export const getImageData = image => {
	if (image === null) return null;
	if (image && image.byteData) return image.byteData;
	return undefined;
};
